import { NavItem } from 'svnxii-ng-shared/components';
import {
  WarehouseIcon,
  StoreLocation01Icon,
  GroupItemsIcon,
  Archive02Icon,
  PackageReceiveIcon,
  PackageSentIcon,
  AddToListIcon,
  Clock03Icon,
  DatabaseIcon,
  PackageIcon,
  QrCodeIcon,
  User03Icon,
  ArrowDataTransferHorizontalIcon,
  Layers01Icon,
} from '@hugeicons/core-free-icons';

const hiddenForInventoryManager = (baselineKey: string | undefined) =>
  baselineKey !== 'InventoryManager';

export const INVENTORY_NAV_ITEMS: NavItem[] = [
  
  {
    title: 'Inventory',
    icon: WarehouseIcon,
    route: '/app/inventory/inventory-list',
    isVisible: hiddenForInventoryManager,
  },
  {
    title: 'Locations',
    icon: StoreLocation01Icon,
    route: '/app/inventory/inventory-locations',
  },
  {
    title: 'Item Categories',
    icon: GroupItemsIcon,
    route: '/app/inventory/item-categories',
  },
  { title: 'Item Cards', icon: Archive02Icon, route: '/app/inventory/item-cards' },
  {
    title: 'Inbound Orders',
    icon: PackageReceiveIcon,
    route: '/app/inventory/inbound-orders',
  },
  {
    title: 'Outbound Orders',
    icon: PackageSentIcon,
    route: '/app/inventory/outbound-orders',
  },
  {
    title: 'Opening Balance',
    icon: AddToListIcon,
    route: '/app/inventory/opening-balance',
  },
  {
    title: 'Transfer Orders',
    icon: ArrowDataTransferHorizontalIcon,
    route: 'transfer-orders',
  },
  {
    title: 'Replenish Requests',
    icon: Layers01Icon,
    route: '/app/inventory/replenish-requests',
    isVisible: (baselineKey) => baselineKey === 'WarehouseOperationsManager',
  },
  {
    title: 'Stock Movement',
    icon: Clock03Icon,
    route: '/app/inventory/stock-movement',
  },
  {
    title: 'Current Stock',
    icon: PackageIcon,
    route: '/app/inventory/current-stock',
  },
  {
    title: 'Inventory Items',
    icon: DatabaseIcon,
    route: '/app/inventory/inventory-item-units',
  },
  {
    title: 'Batch Records',
    devFeature: true,
    icon: QrCodeIcon,
    route: '/app/inventory/batch-items',
  },
  {
    title: 'Account',
    devFeature: true,
    icon: User03Icon,
    route: '/app/inventory/notifications',
  },
];
